import { HTMLAttributes } from 'react';
import { cx } from '@emotion/css';

interface HeaderItemBoxProps extends HTMLAttributes<HTMLSpanElement> {
  className?: string;
}

export const HeaderItemBox = (props: HeaderItemBoxProps) => {
  const { children, className, ...otherProps } = props;

  return (
    <span
      className={cx(
        'h-[20px] bg-[#FFFFFF] rounded-[2px] text-[#515359] leading-[20px] px-2 text-nowrap',
        className,
      )}
      {...otherProps}
    >
      {children}
    </span>
  );
};
